// src/hooks/useAutoLogout.js
// Versi SEDERHANA - Auto logout langsung tanpa peringatan
import { useEffect, useRef, useCallback } from 'react';

const useAutoLogout = (onLogout, isAuthenticated) => {
  const INACTIVITY_TIMEOUT = 2 * 60 * 60 * 1000; // 2 jam dalam milidetik
  
  const timeoutRef = useRef(null);

  const resetTimer = useCallback(() => {
    // Clear existing timer
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set logout timer
    timeoutRef.current = setTimeout(() => {
      alert('Sesi Anda telah berakhir karena tidak ada aktivitas selama 2 jam. Silakan login kembali.');
      onLogout();
    }, INACTIVITY_TIMEOUT);
    
    // Simpan waktu terakhir aktivitas
    localStorage.setItem('lastActivity', Date.now().toString());
  }, [onLogout, INACTIVITY_TIMEOUT]);

  const checkInactivity = useCallback(() => {
    const lastActivity = localStorage.getItem('lastActivity');
    if (lastActivity) {
      const timeSinceLastActivity = Date.now() - parseInt(lastActivity);
      
      // Jika sudah lebih dari 2 jam, logout langsung
      if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) {
        alert('Sesi Anda telah berakhir karena tidak ada aktivitas. Silakan login kembali.');
        onLogout();
        return false;
      }
    }
    return true;
  }, [onLogout, INACTIVITY_TIMEOUT]);

  useEffect(() => {
    if (!isAuthenticated) {
      // Clear timer dan localStorage saat logout
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      localStorage.removeItem('lastActivity');
      return;
    }

    // Check inactivity saat component mount
    if (!checkInactivity()) return;

    // Events yang dianggap sebagai aktivitas user
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
      'keydown'
    ];

    // Reset timer saat ada aktivitas
    const handleActivity = () => {
      resetTimer();
    };

    // Set initial timer
    resetTimer();

    // Tambahkan event listeners
    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // Check inactivity saat tab menjadi visible kembali
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        if (!checkInactivity()) return;
        resetTimer();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
      
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated, resetTimer, checkInactivity]);

  return null;
};

export default useAutoLogout;